import template from "./sign-up-page.html";

const SignUpPageComponent = {
  template: template,

  controller: class SignUpPageController {
    /* @ngInject */
    constructor($rootScope, $window, $scope, $state, $filter, SecurityManager, SweetAlertService, Utils) {
      this.$rootScope = $rootScope;
      this.$window = $window;
      this.$scope = $scope;
      this.$state = $state;
      this.$filter = $filter;
      this.SecurityManager = SecurityManager;
      this.SweetAlertService = SweetAlertService;
      this.Utils = Utils;
    }

    $onInit() {
      this.loading = false;
      this.name = null;
      this.surname = null;
      this.email = null;
      this.password = null;
      this.emailError = false;
      this.passwordPattern = "^(?=.*[0-9])(?=.*[a-zA-Z]).{8,20}$";

      if (this.SecurityManager.isAuthenticated()) {
        this.$state.go("index");
      }

      this.$scope.$watch(
        () => this.email,
        (newVal, oldVal) => {
          if (this.emailError && !angular.equals(newVal, oldVal)) this.emailError = false;
        },
      );
    }

    async signUp() {
      this.emailError = false;

      if (!this.form.$valid) {
        return;
      }

      this.SweetAlertService.processingRequest();
      this.loading = true;

      const locale = this.$window.navigator.language.split("-")[0] === "es" ? "es" : "en";

      try {
        const user = await this.SecurityManager.signUp(this.name, this.surname, this.email, this.password, locale);
        this.SecurityManager.storeCredentials(user.accessToken);
        this.$rootScope.user = user;
        this.SweetAlertService.close();
        this.$state.go("index");
      } catch (e) {
        this.SweetAlertService.close();
        this.loading = false;
        if (e.data === "Email is already registered") {
          this.error = this.$filter("trans")("errors.auth.registeredEmail");
        } else {
          throw e;
        }
        this.$rootScope.$applyAsync();
      }
    }

    goLogin() {
      this.$state.go("login");
    }
  },
};

export default SignUpPageComponent;
